import { motion } from "framer-motion";
import { Quote } from "lucide-react";

const EASE = [0.76, 0, 0.24, 1];

const testimonials = [
    {
        quote: "Throughout our engagement, we have found Zami Concept to be reliable, professional, and responsive. Their team keeps to agreed schedules and addresses issues promptly.",
        name: "Quality & Regulatory Affairs Manager",
        role: "Beiersdorf Nigeria Ltd (makers of Nivea)",
    },
    {
        quote: "I found their team and supervisors to be professional, diligent, and dependable, and any staffing gaps were covered without disruption to operations.",
        name: "Country Engineering Manager",
        role: "Unilever Nigeria",
    },
    {
        quote: "We hand them the site and stop thinking about cleaning. The monthly reports tell us exactly where things stand.",
        name: "Managing Director",
        role: "Color Plus Limited",
    },
];

export default function Testimonials() {
    return (
        <section className="py-24 md:py-32 px-6 md:px-12 bg-linen border-y border-edge" data-testid="testimonials-section">
            <div className="max-w-7xl mx-auto">
                <motion.div
                    initial={{ opacity: 0, y: 32 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true, margin: "-80px" }}
                    transition={{ duration: 0.9, ease: EASE }}
                    className="mb-14 md:mb-20"
                >
                    <p className="text-xs font-bold tracking-[0.25em] uppercase text-fern mb-4">Testimonials</p>
                    <h2 className="font-serif font-medium tracking-tight leading-tight text-3xl sm:text-4xl lg:text-5xl text-forest max-w-2xl text-balance">
                        What our clients say
                    </h2>
                </motion.div>

                <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
                    {testimonials.map((t, i) => (
                        <motion.figure
                            key={t.name}
                            data-testid={`testimonial-card-${i}`}
                            initial={{ opacity: 0, y: 40 }}
                            whileInView={{ opacity: 1, y: 0 }}
                            viewport={{ once: true, margin: "-60px" }}
                            transition={{ duration: 0.8, ease: EASE, delay: i * 0.12 }}
                            className="bg-background border border-edge rounded-3xl p-8 md:p-10 flex flex-col hover:shadow-sm transition-shadow duration-300"
                        >
                            <Quote className="w-6 h-6 text-sage mb-6" strokeWidth={1.5} />
                            <blockquote className="font-serif text-xl md:text-2xl font-medium leading-snug text-forest mb-8 flex-1">
                                “{t.quote}”
                            </blockquote>
                            <figcaption>
                                <p className="text-sm font-bold text-ink">{t.name}</p>
                                <p className="text-xs font-light tracking-wide text-fern mt-1">{t.role}</p>
                            </figcaption>
                        </motion.figure>
                    ))}
                </div>
            </div>
        </section>
    );
}
